export default __webpack_public_path__ + "static/RC_how_we_do_it_icons-02-34b6aa63203ec55d905313c26d9381c1.png";